import { catchError, of } from "rxjs";
import { logE } from "@blacknut/logging/dist";
import apiService, { TAG } from "../../ApiService";

export enum BoostStatus {
  ACCEPTED = "ACCEPTED",
  ACTIVATED = "ACTIVATED",
  REFUSED = "REFUSED",
  RELEASED = "RELEASED",
}
export const boostStatus = () => {
  return apiService
    .get<{ status: BoostStatus }>({
      path: `v1/store/ericsson/boost`,
    })
    .pipe(
      catchError((e) => {
        logE(TAG, "Caught error getting status: %o", e);
        return of({ status: BoostStatus.REFUSED });
      }),
    );
};
